import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface PaymentAddonState {
  addon_product_id?: string;
  description?: string;
  discount?: number;
  image_name?: string;
  is_free?: boolean;
  is_free_shipping?: boolean;
  is_sold_out?: boolean;
  label?: string;
  per_month?: boolean;
  price?: number; // Price without taxes
  regular_price?: number;
  sale_item_id?: string;
  shipping_address_required?: boolean;
  title?: string;
  type?: string;
  sales_tax_amount?: number;
  sales_tax_rate?: number;
  is_tax_inclusive?: boolean;
  hasOffer: boolean;
}

const paymentAddonSlice = createSlice({
  name: "paymentAddon",
  initialState: {
    hasOffer: false,
    sales_tax_amount: 0,
    sales_tax_rate: 0,
  } as PaymentAddonState,
  reducers: {
    updatePaymentAddon(
      state,
      action: PayloadAction<Partial<Omit<PaymentAddonState, "hasOffer">>>
    ) {
      return { ...state, ...action.payload };
    },
  },
});

export const getAddOnTotalPrice = (
  paymentAddon: Partial<PaymentAddonState>
) => {
  if (!paymentAddon) {
    return 0;
  }

  return paymentAddon.is_tax_inclusive
    ? paymentAddon.price
    : paymentAddon.price + paymentAddon.sales_tax_amount;
};

export const { updatePaymentAddon } = paymentAddonSlice.actions;

export default paymentAddonSlice;
